// extracted by mini-css-extract-plugin
module.exports = {"container":"Caption_container__3ncyY","bold":"Caption_bold__3Bmzp","faded":"Caption_faded__3oBko","error":"Caption_error__3PLxb"};